import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap } from "react-google-maps"
import Config from '../../Config/index';
import Language from '../../../lang';

const MyMapComponent = withScriptjs(withGoogleMap(
  ({ onMapLoad, ...props}) => <GoogleMap
    defaultZoom={8}
    defaultCenter={{ lat: 46.9650572, lng: 8.3817774 }}
    ref={e => onMapLoad && onMapLoad(e)}
    {...props}
  />
));

const MyGoogleMap = (props) => (
  <MyMapComponent
    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${Config.googleMapsApiKey}&v=3.exp&libraries=geometry,drawing,places&language=${Language.lang}`}
    loadingElement={<div style={{ height: `100%` }} />}
    containerElement={<div style={{ height: `400px` }} />}
    mapElement={<div style={{ height: `100%` }} />}
    {...props}
  />
);

export default MyGoogleMap;


// WEBPACK FOOTER //
// ./src/App/Components/GoogleMap/index.js